import { gql } from "@apollo/client";


export const GET_PLANNER_ITEM_LINK_GQL = gql`
query GET_PLANNER_ITEM_LINK_GQL($id: ID!){
  plannerItemLink(id: $id){
      id
      text
      url
      sorting
      logo {
        id
        filename
        mediaUrl
        heading
        text
      }
  }
}`

export const UPDATE_ITEM_LINK_GQL = gql`
mutation updatePlannerItemLink($input: UpdatePlannerItemLinkInput!){
    updatePlannerItemLink(input:$input){
        id
    } 
}`
